import * as React from 'react';
import { BasicResponsiveImage } from '../../responsive-image/basic-responsive-image.js';
import { ProgressiveImage } from '../../progressive-image/progressive-image.component.js';
import { FluidImage } from '../../fluid-image/fluid-image.component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var Img = function Img(props) {
  if (props.variant === 'responsive') {
    return /*#__PURE__*/React.createElement(BasicResponsiveImage, _object_spread_props(_object_spread({}, props), {
      variant: undefined
    }));
  }

  if (props.variant === 'progressive') {
    return /*#__PURE__*/React.createElement(ProgressiveImage, _object_spread_props(_object_spread({}, props), {
      variant: undefined
    }));
  }

  return /*#__PURE__*/React.createElement(FluidImage, _object_spread_props(_object_spread({}, props), {
    variant: undefined
  }));
};

Img.displayName = 'Img';
Img.defaultProps = {
  variant: 'fluid'
};
export { Img };